/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.15"
        height="94.33"
        viewBox="0 0 85.15 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M18.52 22.84a1.25 1.25 0 0 1 .12 2.49H11.4a8.88 8.88 0 0 0-8.89 8.68v24.25a1.38 1.38 0 0 0 1.26 1.41h5.36a1.27 1.27 0 0 1 1.23 1.28 1.25 1.25 0 0 1-1.1 1.21H3.89A3.89 3.89 0 0 1 0 58.49V34.23a11.41 11.41 0 0 1 11.11-11.39ZM29.17 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M35.77 49.67a1.27 1.27 0 0 1 1.22 1.13v7.62a3.87 3.87 0 0 1-3.69 3.68h-4.13v20.8a1.26 1.26 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.13V60.9a1.26 1.26 0 0 1 1.09-1.23h5.35a1.39 1.39 0 0 0 1.39-1.27v-7.37a1.25 1.25 0 0 1 1.26-1.36ZM25.63 22.84A11.39 11.39 0 0 1 37 33.94v1.91a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09v-1.74a8.89 8.89 0 0 0-8.63-8.89h-7.36a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 82.95v11.39"/>
        <path
          fill="#fff"
          d="M19.77 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 60.84v22.1"/>
        <path
          fill="#fff"
          d="M18.52 59.59a1.24 1.24 0 0 1 1.25 1.08V82.9a1.24 1.24 0 0 1-1.23 1.25 1.27 1.27 0 0 1-1.25-1.12V60.84a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 82.95v11.39"/>
        <path
          fill="#fff"
          d="M10.37 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 39.51v43.44"/>
        <path
          fill="#fff"
          d="M9.12 38.26a1.26 1.26 0 0 1 1.25 1.12v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V39.51a1.25 1.25 0 0 1 1.24-1.25ZM18.52.01a9.83 9.83 0 1 0 9.83 9.83A9.83 9.83 0 0 0 18.52.01Zm0 2.5a7.33 7.33 0 1 1-7.32 7.33 7.33 7.33 0 0 1 7.32-7.33ZM73.77 22.84a11.39 11.39 0 0 1 11.4 11.1v24.51a3.87 3.87 0 0 1-3.69 3.68h-5.46a1.24 1.24 0 0 1-1.31-1.19 1.26 1.26 0 0 1 1.19-1.31h5.35a1.38 1.38 0 0 0 1.39-1.26V34.5a.31.31 0 0 1 0-.19v-.08h-.09a8.88 8.88 0 0 0-8.53-8.89h-7.38a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h7.26ZM58.48 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M49.37 49.67a1.25 1.25 0 0 1 1.24 1.13v7.43a1.38 1.38 0 0 0 1.26 1.44h5.36a1.26 1.26 0 0 1 1.24 1.13v22.17a1.251 1.251 0 1 1-2.5.12v-20.9h-4a3.9 3.9 0 0 1-3.88-3.7v-7.44a1.25 1.25 0 0 1 1.2-1.3ZM66.64 22.84a1.25 1.25 0 0 1 .12 2.49h-7.24a8.89 8.89 0 0 0-8.9 8.68v1.88a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09v-2a11.4 11.4 0 0 1 11.11-11.1h7.41Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 82.95v11.39"/>
        <path
          fill="#fff"
          d="M67.89 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 60.84v22.1"/>
        <path
          fill="#fff"
          d="M66.64 59.59a1.24 1.24 0 0 1 1.24 1.12v22.23a1.24 1.24 0 0 1-1.23 1.25 1.27 1.27 0 0 1-1.25-1.12V60.84a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 82.95v11.39"/><path
          fill="#fff"
          d="M77.28 82.95v11.39h-2.51V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 39.51v43.44"/><path
          fill="#fff"
          d="M76 38.26a1.26 1.26 0 0 1 1.25 1.12v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.2-1.09V39.51A1.25 1.25 0 0 1 76 38.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M66.63.01a9.83 9.83 0 1 0 9.83 9.83A9.83 9.83 0 0 0 66.63.01Zm0 2.5a7.33 7.33 0 1 1-7.32 7.33 7.33 7.33 0 0 1 7.32-7.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M65.18 42.01a1.49 1.49 0 0 1 1.58 1.42 1.51 1.51 0 0 1-1.43 1.58H18.47a1.51 1.51 0 0 1-1.57-1.43 1.49 1.49 0 0 1 1.43-1.57Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M60.32 35.24a1.49 1.49 0 0 1 2-.05l.11.1 6.9 7.22a1.49 1.49 0 0 1 .09 2l-.09.11-6.77 7.05a1.513 1.513 0 0 1-2.27-2l.1-.12 5.78-6-5.91-6.17a1.51 1.51 0 0 1-.06-2Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleOneWayArrowIcon';

export default Icon;
